// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"ea3a8012","845":"1e69d40b"}[chunkId] + ".chunk.js";
};